<template lang="">
  <div class="msgWindow">
    <div class="msgHeader">
      <p>消息列表</p>
      <span @click="$store.commit('changeMsgWindow')">✖</span>
    </div>
    <table class="newListTable">
      <tr v-for="(item, index) in tableData.newList" :key="item.Id" :class="{isRead:item.State == 1?true:false}" @click="rowClick(item.Id)">
        <td>
          <div>
            <el-tooltip class="item" effect="dark" :content="item.Title" placement="top-start">
              <div> {{item.Title}}</div>
            </el-tooltip>
          </div>
        </td>
        <td v-html ="formatTime(item.CreateTime)"></td>
        <td>{{item.EmpName}}</td>
      </tr>
    </table>
    <el-dialog class="msgDialog"
               :visible.sync="dialogVisible"
               width="1050px"
               :title="currentItem.Title"
               :close-on-click-modal="false"
               :modal-append-to-body="false">
      <div v-html="currentItem.Content"></div>
      <div class="dialog-footer" slot="footer">
        <el-button type="default"
                   size="medium"
                   icon="iconfont icon-font-close"
                   @click="dialogVisible=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import request from '@/utils/request'
import moment from 'moment'

export default {
    data() {
      return {
        tableData: {
          newList:[],
          readTotal:0,
          unreadTotal:0,
          total:0
        },
        dialogVisible: false,
        currentItem:{}
      }
    },
    methods: {
      formatTime(time) {
        var date = new Date(time)
        return moment(date).format("YYYY-MM-DD")
      },
      rowClick(id){
        this.dialogVisible = true
        this.loading = true;
        request.post('/api/Biz/GetNewInfoById', { NewId: id }).then((r) => {
          this.loading = false;
          if (r.Flag == 1) {
            this.currentItem = r.Data;
            if (!this.currentItem)
              return;
            let currentIndex = this.tableData.newList.findIndex((item) => item.Id == id)
            this.currentItem.State = this.tableData.newList[currentIndex].State
            if (this.currentItem.State != 1) {//未读
              this.loading = true;
              request.post('/api/Biz/ReadNew', { NewId: this.currentItem.Id }).then((r) => {
                this.loading = false;
                if (r.Flag == 1) {
                  this.$message.success(this.currentItem.Title + '已读');
                  this.getNewsList();
                }
                else {
                  this.$alert('已读失败：' + r.ErrorMsg, {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'iconfont icon-font-success',
                    iconClass: 'iconfont icon-font-error',
                    customClass: 'custom-message-box-1',
                    dangerouslyUseHTMLString: true,
                  });
                }
              })
            }
          } else {
            this.$alert('获取单个失败：' + r.ErrorMsg, {
              confirmButtonText: '确定',
              confirmButtonClass: 'iconfont icon-font-success',
              iconClass: 'iconfont icon-font-error',
              customClass: 'custom-message-box-1',
              dangerouslyUseHTMLString: true,
            });
          }
        })
      },
      getNewsList(state) {
        this.loading = true;
        request.post('/api/Biz/GetNewsListByEmpId',{ State: state}).then((r) => {
          this.loading = false;
            this.tableData.newList = r.Data;
          if (this.tableData.newList == 0)
            this.$store.commit('closeMsgWindow');
          this.setNewsUnreadLength();
        })
      },
      //设置未读数量
      setNewsUnreadLength() {
        let unReadNewsCount = this.tableData.newList.filter(function (item) {
          if (item.State != 1)
            return item
        }).length;
        this.$store.commit('changeUnReadNewsCount', unReadNewsCount);
      },
      //刷新
      refresh(state) {
        this.getNewsList(state)
      }
    },
    mounted() {
      this.refresh(this.$store.state.newState)
    },
}
</script>
<style lang="" scoped>
.msgWindow{
    position: absolute;
    right: 10px;
    bottom: 10px;
    background-color: rgb(255, 255, 255);
    border-radius: 5px;
    box-shadow: 0px 0px 20px #c0c0c0;
    z-index: 10;
}
.msgWindow .msgHeader{
    height: 32px;
    background-color: rgba(208, 233, 249,0.3);
    border-radius: 4px;
}
  .msgWindow p {
    display: inline-block;
    margin-left: 10px;
    margin-top: 5px;
  }
.msgWindow span:hover{
    cursor:pointer;
}
.msgHeader > p {
  color: rgb(51, 51, 51);
  letter-spacing: 2px;
  font-weight: 700;
  margin-left: 12px;
  font-size: 14px;
}
.msgDialog >>> .el-dialog__header{
    /* border-bottom: 1px solid black; */
    height: 50px;
    line-height: 50px;
}
.msgDialog >>> .el-dialog__header .el-dialog__title{
    display: inline-block;
    color: black;
    font-size: 24px;
    font-weight: normal;
    width: calc(100% - 30px);
    line-height: 50px;
    /*border-bottom: 1px solid #aacafb;*/
    text-overflow: ellipsis; 
    white-space: nowrap; 
    overflow: hidden; 
}
  .msgDialog >>> .el-dialog__body {
    margin: 0;
    box-sizing: border-box;
    padding: 30px 30px;
    width: 100%;
    min-height: 200px;
    border-bottom: 1px solid #aacafb;
    border-top: 1px solid #aacafb;
  }

table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 408px;
  max-height: 300px;
  display: block;
  overflow: auto;
}
  tr {
    border-bottom: 1px dashed rgba(185, 189, 190,0.5);
    cursor: pointer
  }
tr:last-child{
    border-bottom: 0;
}
tr:hover{
    background-color: #f5f7fa;
    transition: 0.2s;
}
td{
    white-space: nowrap;
    font-size: 14px;
    line-height: 36px;
    padding: 0 5px;
    font-family: "SimSun" !important;
}
  td:nth-child(1) {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    width: 200px;
    color: rgb(15, 127, 233);
    margin-left: 8px;
  }
td:nth-child(2){
    width: 140px;
    color: rgb(51, 51, 51);
}
.isRead td:nth-child(1){
    color: rgb(141, 126,130);
}
.title{
    margin:0;
    margin-bottom: 10px;
}
.msgHeader span{
    font-size: 16px;
    font-weight: 100;
    float: right;
    margin-right: 12px;
    margin-top:4px;
}
.kindeditor{
    margin-bottom: 20px;
}
.kindeditor >>> .ke-toolbar,
.kindeditor >>> .ke-statusbar{
    display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/layout/compones/msgWindow.vue